module.exports = __webpack_public_path__ + "5f59e94ce279457daca5c9f577ab8a97.svg";